import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { QueryClient, QueryClientProvider } from "react-query"
import { BrowserRouter as Router } from "react-router-dom"
import { ReactQueryDevtools } from "react-query/devtools"

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } })

export const numberFormatter = Intl.NumberFormat()

ReactDOM.render(
   <React.StrictMode>
      <QueryClientProvider client={queryClient}>
         <Router>
            <App />
         </Router>
         <ReactQueryDevtools />
      </QueryClientProvider>
   </React.StrictMode>,
   document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
